import { createFileRoute } from "@tanstack/react-router";
import { CatalogPage, isCatalogTab, type CatalogTab } from "@/components/admin/catalog/CatalogPage";

export const Route = createFileRoute("/dashboard/admin/catalog/")({
  validateSearch: (search: Record<string, unknown>): { tab?: CatalogTab } =>
    isCatalogTab(search.tab) ? { tab: search.tab } : {},
  component: CatalogRoute,
});

function CatalogRoute() {
  const { tab } = Route.useSearch();
  return <CatalogPage tab={tab ?? "services"} />;
}
